import './Rules.css';
import React from 'react';

import config from '@config';
import Metas from '@views/Metas';

import rulesContent from './rulesContent';

/**
 * Contenido editables: reemplazá los párrafos y h2 por el texto definitivo.
 */
export const Rules = () => (
  <div className="Rules">
    <Metas
      title="Cómo funciona el sistema de puntos — Prode 2026"
      description="Explicación del sistema de puntajes del Prode 2026 de Página/12."
      path="reglas"
    />
    <div className="hero-bg">
      <div className="hero-content">
        <h2>Reglas del Prode</h2>
      </div>
    </div>

    <div className="rules-content">
      <div className="rules-content__inner">
        <div
          className="terms-html"
          dangerouslySetInnerHTML={{ __html: rulesContent }}
        />
      </div>
    </div>
  </div>
);

Rules.displayName = 'Rules';

export default Rules;
